const state = {
	requirements_index: {
		data: [{ code: '111' }],
		links: {},
		meta: {},
	},
};

export default state;
